import React, { useEffect, useState } from 'react';
import { Dropdown, List, SearchBox } from 'tea-component';
import './index.scss';
import moment from 'moment';
import { getLocale, useIntl } from 'umi';

export default function MultipleDropSelect(props: {
  handleReportChange?: (value: any) => void;
  handleInit?: (value: any) => void;
  reportInsightConfig: any[];
}) {
  const monthStr = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const zhMonthStr = [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ];

  const [year, setYear] = useState('');
  const [groups, setGroups] = useState([]);
  const [cur, setCur] = useState<any>({});
  const [search, setSearch] = useState('');
  const [data, setData] = useState<any[]>([]);
  const language = getLocale();
  useEffect(() => {
    setData(props.reportInsightConfig || []);
  }, [props.reportInsightConfig]);

  const yearMap: any = {}; 
  for (let index = 0; index < data.length; index += 1) {
    const item = data[index];
    const { date, title } = item;
    const year = moment(date).year();

    if (search) {
      if (!year.toString().includes(search) && !title.includes(search))
        continue;
    }

    if (!yearMap[year]) {
      yearMap[year] = [item];
    } else {
      yearMap[year].push(item);
    }
  }

  const yearMapEntity = Object.entries(yearMap).sort(([year1], [year2]) => {
    return parseInt(year2) - parseInt(year1);
  });

  const options: any[] = [];
  yearMapEntity.map(([key, children]) => {
    options.push({
      title: key,
      children,
    });
  });

  options.map((item) => {
    const { children = [] } = item;
    const groupMap: any = {};
    for (let index = 0; index < children.length; index += 1) {
      const item = children[index];
      const { date } = item;
      const month = moment(date).month();

      if (!groupMap[month]) {
        groupMap[month] = [item];
      } else {
        groupMap[month].push(item);
      }
    }

    const groupMapEntries = Object.entries(groupMap).sort(
      ([month1], [month2]) => {
        return parseInt(month2) - parseInt(month1);
      },
    );

    const groups: any[] = [];
    groupMapEntries.map(([key, children]) => {
      groups.push({
        title: key,
        children,
      });
    });

    item.groups = groups;
  });

  const optionsMap = options.reduce((obj, cur) => {
    const newObj = Object.assign(obj);
    const { title } = cur;
    newObj[title] = cur;
    return newObj;
  }, {});

  const handleYearClick = (title: string) => {
    setYear(title);
    setGroups(optionsMap[title].groups);
  };

  const handleReportChange = (child: any = {}, close: { (): void; (): void }) => {
    props.handleReportChange?.(child);
    setCur(child);
    close();
  };

  useEffect(() => {
    if (Array.isArray(options) && options.length > 0) {
      const curYear = options[0].title;
      const curGroups = optionsMap[curYear].groups;

      console.log(curYear, curGroups);

      setYear(curYear);
      setGroups(curGroups);
      const obj = curGroups?.[0]?.children?.[0] || {};
      setCur(obj); 
      props.handleInit?.(obj);
    }
  }, [data]);

  const handleSearchClear = () => {};
  const handleSearchChange = (value: string) => {
    setSearch(value.trim());
  };
  const { formatMessage } = useIntl();
  useEffect(() => {
    setGroups(options?.[0]?.groups || []);
  }, [search]);
  return (
    <Dropdown
      className="dbo-report-select"
      destroyOnClose={false}
      button={
        <>
          <span className="select-button-text">
            {formatMessage({ id: 'Report' })}
          </span>
          <span className="select-button-value">
            {language === 'zh-CN' ? cur?.title : cur?.title_en || cur?.title}
          </span>
        </>
      }
      appearance="button"
      clickClose={false}
      boxClassName="dbo-report-select-container"
    >
      {(close) => (
        <>
          <SearchBox
            placeholder={formatMessage({ id: 'Search' })}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
          />
          <div className="dbo-report-select-content-container">
            <div className="dbo-report-select-content-wrap">
              <List type="option-group">
                <div className="dbo-report-select-content-title-wrap">
                  <span>{formatMessage({ id: 'Year' })}</span>
                </div>
                {options.map((option) => (
                  <List.SubMenu
                    label={option.title}
                    key={option.title}
                    onClick={() => handleYearClick(option.title)}
                    className={`dbo-report-dropdown-item ${
                      option.title === year ? 'active' : ''
                    }`}
                  ></List.SubMenu>
                ))}
              </List>
            </div>
            <div className="dbo-report-select-content-wrap">
              <List type="option-group">
                {groups.map((item: any) => (
                  <>
                    <div className="dbo-report-select-content-title-wrap">
                      <span>
                        {language === 'zh-CN'
                          ? zhMonthStr[item.title]
                          : monthStr[item.title]}
                      </span>
                    </div>

                    {item.children?.map(
                      (child: {
                        date: any;
                        title: string;
                        title_en: string;
                      }) => (
                        <List.Item
                          className={`dbo-report-dropdown-item dbo-report-dropdown-singleitem ${
                            child.date === cur?.date ? 'active' : ''
                          }`}
                          key={child.title}
                          onClick={() => handleReportChange(child, close)}
                        >
                          {language === 'zh-CN'
                            ? child.title
                            : child.title_en || child.title}
                        </List.Item>
                      ),
                    )}
                  </>
                ))}
              </List>
            </div>
          </div>
        </>
      )}
    </Dropdown>
  );
}
